import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Threefiveseaterbusonrentinahmednagar() {



  const cardData =
  {
    keyword: '35 Seater Bus on Rent in Ahmednagar',
    heading: 'Sanavi Travels: 35 Seater Bus on Rent in Ahmednagar',
    headingDescription: 'Sanavi Travels offers 35 Seater Bus on Rent in Ahmednagar, providing safe, comfortable, and spacious transportation for families, groups, corporate trips, school excursions, weddings, and outstation journeys. Our fleet of well-maintained 35-seater AC and Non-AC buses ensures smooth rides, ample seating, and sufficient luggage space for a hassle-free travel experience. With professional drivers, flexible one-way and round-trip rental packages, transparent pricing, and 24/7 booking support, renting a 35-seater bus in Ahmednagar is perfect for local travel, sightseeing tours, group outings, and long-distance trips. Choose Sanavi Travels for trusted 35-seater bus rental services in Ahmednagar, delivering comfort, safety, and a seamless travel experience every time.',

    top: 'Top Places to Visit in Ahmednagar with Sanavi Travels',


"topPlaces": [
  {
    "title": "Ahmednagar City",
    "description": "Ahmednagar is a historic city in Maharashtra known for its rich cultural heritage, medieval forts, and spiritual significance. Located in the heart of the state, it played a prominent role during the Nizam Shahi and Maratha periods. The city is famous for its historical monuments, Sufi shrines, and rural charm, making it a mix of history, spirituality, and cultural tourism."
  },
  {
    "title": "Ahmednagar Fort",
    "description": "Ahmednagar Fort is a 15th-century structure built by Ahmad Nizam Shah I. It has served as a military stronghold, prison, and royal residence over the centuries. The fort houses several tombs, mosques, and temples inside its expansive walls. Its historical importance, architecture, and panoramic views make it a popular site for history enthusiasts and photographers."
  },
  {
    "title": "Shirdi Sai Baba Temple (Nearby)",
    "description": "Ahmednagar is located close to Shirdi, the spiritual center of Sai Baba devotees. Pilgrims traveling from Ahmednagar often visit the Sai Baba Temple, which is one of India’s most famous spiritual destinations, attracting millions of devotees annually."
  },
  {
    "title": "Grishneshwar Jyotirlinga (Near Ellora Caves)",
    "description": "Located within reach from Ahmednagar, Grishneshwar Temple is a Jyotirlinga dedicated to Lord Shiva. Its intricate carvings and sanctum attract pilgrims seeking spiritual blessings and a glimpse into ancient Indian architecture. The temple is often combined with visits to the nearby Ellora Caves."
  },
  {
    "title": "Siddheshwar Temple",
    "description": "Siddheshwar Temple is a significant Shiva shrine in Ahmednagar city. Devotees visit to perform rituals, celebrate festivals, and seek spiritual solace. The temple’s architecture and local legends make it an important part of the city’s religious fabric."
  },
  {
    "title": "Stepwells and Historical Water Structures",
    "description": "Ahmednagar houses several ancient stepwells and water reservoirs built during the medieval period. These structures reflect advanced engineering and architectural skills of the time, offering insights into the city’s urban planning and water management history."
  },
  {
    "title": "Cultural Festivals and Fairs",
    "description": "Ahmednagar celebrates various religious and cultural festivals such as Ganesh Chaturthi, Mahashivratri, and Urs with grandeur. Local fairs showcase folk music, dance, and crafts, providing visitors an immersive experience of regional traditions."
  },
  {
    "title": "Rural Villages and Agriculture",
    "description": "The countryside around Ahmednagar is fertile and predominantly agricultural, cultivating sugarcane, pulses, and vegetables. Exploring nearby villages provides insight into rural life, farming practices, and local cuisine."
  },
  {
    "title": "Sufi Shrines and Dargahs",
    "description": "Ahmednagar has several historic Sufi shrines and dargahs, reflecting the city’s spiritual diversity. These sites are centers of devotion, music, and community gatherings, offering visitors a unique cultural and spiritual experience."
  },
  {
    "title": "Natural Landscapes and Hills",
    "description": "Ahmednagar is surrounded by scenic hills, rivers, and forests. These natural landscapes provide opportunities for trekking, photography, and weekend getaways, especially during the monsoon when the region is lush and vibrant."
  }
]
,



"services": [
{
"name": "35 Seater Bus on Rent in Ahmednagar",
"description": "35 Seater Bus on Rent in Ahmednagar offers spacious, comfortable, and well-maintained buses perfect for families, groups, corporate teams, and tourist excursions. Equipped with modern amenities, professional drivers, and safety-focused features, these buses provide a reliable and smooth journey. Ideal for weddings, long-distance travel, sightseeing tours, and special events, this service ensures convenience, punctuality, and a stress-free travel experience for all passengers."
},
{
"name": "35 Seater Bus Hire Ahmednagar",
"description": "35 Seater Bus Hire Ahmednagar provides flexible rental solutions for small to medium-sized groups. With experienced drivers, well-maintained interiors, and reliable service, it is perfect for weddings, corporate outings, religious tours, and sightseeing trips. Passengers enjoy safety, comfort, and convenience, making it an ideal choice for any planned journey."
},
{
"name": "AC 35 Seater Bus Ahmednagar",
"description": "AC 35 Seater Bus Ahmednagar ensures a cool and refreshing travel experience for passengers during short and long trips. With fully air-conditioned interiors, comfortable seating, and professional drivers, this service is designed to offer maximum comfort and a smooth journey, whether for corporate travel, family outings, or tourist excursions."
},
{
"name": "Luxury Bus Ahmednagar",
"description": "Luxury Bus Ahmednagar provides premium travel solutions with spacious interiors, modern amenities, and professional chauffeurs. Perfect for weddings, corporate events, leisure trips, and long-distance journeys, these luxury buses combine comfort, style, and reliability, offering a memorable and safe travel experience for passengers."
},
{
"name": "Wedding Bus Ahmednagar",
"description": "Wedding Bus Ahmednagar offers elegant, well-maintained buses for transporting guests to and from wedding venues. With comfortable seating, professional drivers, and timely service, it ensures a stress-free, safe, and smooth travel experience, making wedding occasions more organized and enjoyable."
},
{
"name": "Corporate Bus Ahmednagar",
"description": "Corporate Bus Ahmednagar provides professional and dependable transportation for employee commutes, corporate events, team outings, and business trips. Well-maintained buses, punctual service, and experienced drivers ensure safe, efficient, and comfortable travel, enhancing convenience for corporate clients."
},
{
"name": "Outstation Bus Ahmednagar",
"description": "Outstation Bus Ahmednagar offers reliable and comfortable long-distance travel for groups, families, and corporate teams. Spacious seating, modern facilities, and skilled drivers guarantee a safe, convenient, and enjoyable journey for intercity trips, leisure tours, pilgrimages, and business travel."
},
{
"name": "Affordable Bus Ahmednagar",
"description": "Affordable Bus Ahmednagar delivers cost-effective travel solutions without compromising on comfort or safety. Ideal for small groups, families, and individuals, these buses provide well-maintained interiors, professional drivers, and dependable service at competitive rates, making it a perfect option for budget-conscious travelers."
},
{
"name": "Chauffeur Driven Bus Ahmednagar",
"description": "Chauffeur Driven Bus Ahmednagar offers stress-free journeys with professional drivers managing navigation, traffic, and schedules. Ideal for weddings, corporate outings, group tours, and family trips, this service guarantees a smooth, safe, and enjoyable travel experience for all passengers."
},
{
"name": "Best 35 Seater Bus Ahmednagar",
"description": "Best 35 Seater Bus Ahmednagar provides high-quality buses, skilled drivers, and punctual service for various travel needs. Whether for corporate trips, family outings, weddings, or tourist excursions, it ensures safe, reliable, and comfortable transportation for all passengers."
},
{
"name": "Tourist Bus Ahmednagar",
"description": "Tourist Bus Ahmednagar caters to travelers exploring Ahmednagar and nearby attractions. Well-maintained buses with professional drivers provide a comfortable, convenient, and enjoyable travel experience for sightseeing tours, pilgrimages, leisure trips, and family vacations."
},
{
"name": "Group Travel Bus Ahmednagar",
"description": "Group Travel Bus Ahmednagar offers organized transport for friends, families, corporate teams, and tour groups. Comfortable seating, professional drivers, and dependable service ensure smooth, safe, and enjoyable journeys for all members of the group, making group travel hassle-free."
},
{
"name": "Online Bus Booking Ahmednagar",
"description": "Online Bus Booking Ahmednagar allows travelers to reserve 35 seater buses easily with instant confirmation, multiple vehicle options, flexible schedules, and secure payment methods. Perfect for families, corporate groups, tourists, and event organizers, it simplifies travel planning and ensures convenience from start to finish."
},
{
"name": "Event Bus Ahmednagar",
"description": "Event Bus Ahmednagar provides dedicated transportation for weddings, corporate events, parties, social gatherings, and other occasions. Spacious interiors, professional drivers, and reliable service ensure organized, safe, and comfortable travel for all attendees, making event planning seamless."
},
{
"name": "Ahmednagar Travel Bus",
"description": "Ahmednagar Travel Bus offers comprehensive bus services for local travel, sightseeing, corporate events, weddings, and outstation trips. Well-maintained buses, professional drivers, and dependable service guarantee safe, comfortable, and hassle-free journeys for families, groups, and businesses across Ahmednagar and nearby regions."
}
],
"tableData": [
["35 Seater Bus on Rent in Ahmednagar", "35 Seater Bus Hire Ahmednagar"],
["AC 35 Seater Bus Ahmednagar", "Luxury Bus Ahmednagar"],
["Wedding Bus Ahmednagar", "Corporate Bus Ahmednagar"],
["Outstation Bus Ahmednagar", "Affordable Bus Ahmednagar"],
["Chauffeur Driven Bus Ahmednagar", "Best 35 Seater Bus Ahmednagar"],
["Tourist Bus Ahmednagar", "Group Travel Bus Ahmednagar"],
["Online Bus Booking Ahmednagar", "Event Bus Ahmednagar"],
["Ahmednagar Travel Bus", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "35 Seater Bus on Rent in Ahmednagar with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers dependable and comfortable 35 seater bus rental services in Ahmednagar, ideal for large group travels, family outings, corporate tours, and local trips."
  },
  {
    "WhyChooseheading": "Spacious and Well‑Maintained Bus",
    "WhyChoosedescription": "Our 35 seater buses are clean, air‑conditioned, and regularly serviced to ensure a smooth and enjoyable journey throughout Ahmednagar and surrounding areas."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with Ahmednagar routes and nearby regions, ensuring safe, punctual, and stress‑free travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront and clear pricing for 35 seater bus rentals in Ahmednagar, including fuel, tolls, and driver allowances with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your 35 seater bus hire."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from half‑day, full‑day, or customized rental plans based on your group’s schedule and travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicle",
    "WhyChoosedescription": "The 35 seater bus is thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for 35 seater bus rentals in Ahmednagar."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide 35 seater bus rentals in Ahmednagar?',
    answer: 'Yes, Sanavi Travels offers reliable 35 seater bus rental services in Ahmednagar for various travel needs.'
  },
  {
    question: 'How can I book a 35 seater bus in Ahmednagar?',
    answer: 'You can easily book a 35 seater bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What amenities are available in the 35 seater bus?',
    answer: 'Our 35 seater buses offer comfortable seating, air‑conditioning, ample space, and regular maintenance for a pleasant journey.'
  },
  {
    question: 'Are the drivers experienced with routes in Ahmednagar?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with routes in and around Ahmednagar to ensure safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations?',
    answer: 'Yes, you can select your preferred pickup and drop‑off locations anywhere in Ahmednagar and nearby areas.'
  },
  {
    question: 'Is the 35 seater bus service available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock support to help you book your 35 seater bus in Ahmednagar at any time.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are accepted for the 35 seater bus hire?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your 35 seater bus trip in Ahmednagar.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sanjay Kulkarni',
    feedback: 'Booked a 35 seater bus in Ahmednagar with Sanavi Travels — very spacious, comfortable, and excellent service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Anjali Patil',
    feedback: 'Sanavi Travels provided a reliable and clean 35 seater bus for our group travel in Ahmednagar. Highly recommended!',
    rating: 5
  }
];








































































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "BusTrip",
  "name": "35 Seater Bus on Rent in Ahmednagar - Sanavi Travels",
  "description": "Book a 35 seater bus in Ahmednagar with Sanavi Travels. AC and chauffeur-driven buses available for weddings, corporate trips, outstation tours, group travel, events, and tourist trips. Affordable and reliable buses with online booking.",
  "touristType": "Small Group Travel, Wedding, Corporate, Outstation, Tourist",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "22"
  }
};








  return (
    <div>
<Helmet>
  <title>
    35 Seater Bus on Rent in Ahmednagar | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Rent a 35 seater bus in Ahmednagar with Sanavi Travels. AC and chauffeur-driven buses for weddings, corporate trips, outstation tours, group travel, and events. Affordable and reliable buses with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/210.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Threefiveseaterbusonrentinahmednagar;